import CometMarquee from 'comet-marquee';
// import 'comet-marquee/dist/comet-marquee.css';

const clientsMarqueeArr = document.querySelectorAll('.clients-marquee');
clientsMarqueeArr.forEach((clientsMarqueeEl, i) => {
  const clientsMarquee = new CometMarquee(clientsMarqueeEl, {
    speed: 50,
    pauseOnHover: true,
    initialShift: window.innerWidth >= 1033,
    pauseOnInvisible: true,
    syncPause: false,
    repeatCount: 5,
    forceAnimation: window.innerWidth >= 1033,
    forceAnimationWidth: window.innerWidth >= 1033 ? 3 : false,
    fullWidth: window.innerWidth >= 1033,
  });
})